import React, { useState } from 'react';

import Header from './Header';
import Footer from './Footer';
import '../styles/RubberAndPlastic.css';
import OurProductsSection from "./OurProductsSection"

import RubberAndPlasticPdf from '../assets/dummy.pdf'
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import rubberImg from '../assets/solution-rubberImg.jpg';
import RubberAndPlastic1 from '../assets/RubberAndPlastic1.png'
import RubberAndPlastic2 from '../assets/RubberAndPlastic2.png'
import RubberAndPlastic3 from '../assets/RubberAndPlastic3.png'
import RubberAndPlastic4 from '../assets/RubberAndPlastic4.png'
import RubberAndPlastic5 from '../assets/RubberAndPlastic5.png'
import RubberAndPlastic6 from '../assets/RubberAndPlastic6.png'
import RubberAndPlastic7 from '../assets/RubberAndPlastic7.png'

import rubber1 from '../assets/rubber1.jpg'
import rubber2 from '../assets/rubber2.jpg'
import rubber3 from '../assets/rubber3.jpg'
import rubber4 from '../assets/rubber4.jpg'
import rubber5 from '../assets/rubber5.jpg'
import { text } from '@fortawesome/fontawesome-svg-core';

const RubberAndPlastic = () => {
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  return (
    <div className="RubberAndPlastic">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner12">
        <div className="hero-content">
          <h1>Rubber And Plastic</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Rubber And Plastic</span>
          </div>
        </div>
      </section> */}

<section className="RubberAndPlastic-hero-clean">
  <div className="hero-text">
    <h1>Rubber and Plastic Industry</h1>
    <p>
From extrusion monitoring to mold detection and handling automation, our sensors deliver reliable performance in high-temperature and complex rubber and plastic environments.
</p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={rubberImg} alt="RubberAndPlastic Industry" />
  </div>
</section>



 {/* Image & Text Section */}
{/* <section className="packaging-content">
  {[
  { img: RubberAndPlastic1, title: 'Die casting machine', desc: 'Learn how sensors for pressure, temperature,flow and oil quality monitoring help overcome challenges like defects, downtime and inefficiency.' },
  { img: RubberAndPlastic2, title: 'Stamping press', desc: 'Monitor pressure, temperature, vibration and lub-rication in real-time to reduce downtime, improve efficiency and maintain production quality.' },
  { img: RubberAndPlastic3, title: 'Dry vacuum pump', desc: 'Improve the availability of your vacuum pump by means of ifm hardware and software solutions for condition monitoring.' },
  { img: RubberAndPlastic4, title: 'Injection moulding press', desc: 'Discover how integrating sensors in injection moulding machines enhances part quality, reduces defects and minimises downtime.' },
  { img: RubberAndPlastic5, title: 'Induction furnace', desc: 'Enhance your induction furnace performance, safeguard equipment and improve product quality with ifm’s advanced monitoring technology.' },
  { img: RubberAndPlastic6, title: 'Hydraulic Power Unit (HPU)', desc: 'Ensure optimal performance and prevent downtime with advanced monitoring solutions for HPUs.' },
  { img: RubberAndPlastic7, title: 'Air compressor', desc: 'Discover how ifm’s sensors enhance air compressor efficiency and reliability. Prevent failures, reduce downtime and improve energy usage.' }
  ].map((item, idx) => (
    <div className={`packaging-row ${idx % 2 !== 0 ? 'reverse' : ''}`} key={idx}>
      <div className="packaging-image">
        <img src={item.img} alt={item.title} />
      </div>
      <div className="packaging-text">
        <h3>{item.title}</h3>
        <p>{item.desc}</p>
      </div>
    </div>
  ))}
</section> */}


<section className="rubber-injection-machine">
  <div className="machine-image">
    <img src={rubber1} alt="Horizontal injection molding machine" />
  </div>

  <div className="horizontal-card-wrapper">
    {[
      {
        number: "1",
        title: "Hazardous point protection",
        text: `The rugged  Lock safety locking
device locks the sliding protective
cover of the machine, ensuring that
it is impossible to interfere with the
injection molding machine during the
injection molding process. To achieve the required safety level and to reduce the
possibility of manipulation to the safety
locking device, the position of the sliding
protective cover of the machine is also
monitored with the safety position
switch.`
      },
      {
        number: "2",
        title: "Part counting",
        text: `The injection-molded parts are counted
with the FLG frame light grid. The sensor
can be aligned easily and quickly thanks
to the rugged frame design. With a
resolution of up to 2 mm, it is even
possible for the frame light grid to count
small parts. This means, for example,
that when the exact quantities are
determined, a container change can be
carried out.`
      },
      {
        number: "3",
        title: "Flow measurement",
        text: `FFU ultrasonic flowmeters monitor the
flow rate in the tool cooling cycles of the
machine. Thanks to the rugged design of
the sensors - which do not contain any
moving parts - they are even suitable for
use in harsh environmental conditions.`
      },
      {
        number: "4",
        title: "Minimum fill level monitoring",
        text: `To prevent the material feed hopper from
being emptied and machine down-
time occurring as a result, the capacitive proximity sensor detects the
minimum fill level in the feed hopper.
If the minimum fill level is insufficient,
the sensor switches. This signals to
the operator that the material must be
slackened.`
      },
      {
        number: "5",
        title: "Mobile material identification",
        text: `To enhance process reliability, the hand-held scanner reads the
bar code stickers on the material sacks
and transfers the data in the code to the
machine controller. This ensures that the
right material for the job and product in
question is fed to the machine.`
      },
      {
        number: "6",
        title: "Safe machine stop",
        text: `In a hazardous situation, the safe
emergency stop pushbutton can trigger a
machine stop.`
      },
      {
        number: "7",
        title: "Safe machine interior monitoring",
        text: `On a large injection molding machine, it
must be ensured that there are no oper-
ators inside the machine if the machine
process is accidentally started up by a
second operator. Safety laser
scanner is therefore used to monitor the
interior of the machine.`
      }
    ].map((item, idx) => (
      <div className="info-card small" key={idx}>
        <div className="card-title">
          <span className="card-number">{item.number}</span>
          <span className="card-heading">{item.title}</span>
        </div>
        <p>{item.text}</p>
      </div>
    ))}
  </div>
</section>




<section className="rubber-injection-machine">
  <div className="machine-image">
    <img src={rubber2} alt=" Vertical injection molding machine" />
  </div>

  <div className="horizontal-card-wrapper">
    {[
      {
        number: "1",
        title: "Monitoring the position of inserts",
        text: ` When producing hybrid components, 
metallic inserts are positioned in the 
injection molding tool and then insert
molded with plastic. The Inspector vision 
sensor identifies any incorrectly posi
tioned inserts. This prevents machine 
downtime and damage to the tool.`
      },
      {
        number: "2",
        title: "Pressure monitoring during material transportation",
        text: ` To ensure a constant feed of material 
into the machine when providing a 
supply of liquid silicone, PBT pressure 
transmitters measure the pressure in the 
machine lines.`
      },
      {
        number: "3",
        title: "Dynamic hazardous point protection at the sliding table",
        text: ` Because the sliding table performs 
dangerous movements, the hazardous 
area around the table must be safe
guarded. This is achieved using the Flexi 
Soft safety controller in combination with 
S3000 safety laser scanners. Protective 
and warning fields are configured accord
ing to the dangerous movement. This 
means that, as long as there are no dan
gerous situations present, the table can 
be freely accessed in order to remove 
parts. `
      },
      {
        text:`If the table has a servo-elec
tric drive, the safe position and safe 
standstill data for the table can also be 
determined using the MOC motion con
trol component of the Flexi Soft safety 
controller.Please note: A special proto
type test for fulfilling the machine-spe
cific safety design is required for this 
application. It is not possible to adopt 
the application directly without special 
testing. SICK will be happy to support 
you in developing appropriate safety 
concepts for your machine, so that 
they comply with the appropriate safety 
requirements and standards.`
      },
      {
        number: "4",
        title: "Hazardous point protection at the clamping unit",
        text: `The miniTwin4 safety light curtain 
provides a straightforward protection 
method against reaching under and into 
a dangerous area. For this safety appli
cation, two safety light curtains are cas
caded. This provides a safeguard against 
the clamping unit’s hazardous point.`
      },
      {
        number: "5",
        title: "Hazardous point protection at the injection unit",
        text: `The safety camera system secures 
the access opening to the hazardous 
point of the injection unit. No physical 
guards such as doors are required. The 
injection unit is freely accessible.`
      },
      {
        number: "6",
        title: "Hazardous point protection at the rotating table",
        text: `The rotational movement of the table 
can present a danger for the machine 
operator. To eliminate this risk, the 
deTec4 Core safety light curtain is 
mounted at the access opening to the 
hazardous point of the rotating table. 
In a hazardous situation, the safe 
emergency stop pushbutton can also 
trigger a machine stop.`
      },
      {
        number: "7",
        title: " Safe position and end position monitoring",
        text: ` On injection molding machines that 
have a rotating or extending table, the 
end positions of the table are safely 
monitored using the non-contact Direct Inductive safety switch.`
      }
    ].map((item, idx) => (
      <div className="info-card small" key={idx}>
        <div className="card-title">
          <span className="card-number">{item.number}</span>
          <span className="card-heading">{item.title}</span>
        </div>
        <p>{item.text}</p>
      </div>
    ))}
  </div>
</section>







<section className="rubber-injection-machine">
  <div className="machine-image">
    <img src={rubber3} alt=" Automated Production Cell" />
  </div>

  <div className="horizontal-card-wrapper">
    {[
      {
        number: "1",
        title: " Inline quality control",
        text: ` The process of producing injec
tion-molded plastic parts is subject to 
many influences (temperature fluctu
ations, differences in plastic granule 
quality, etc.) Errors such as overfilling or 
underfilling the mold are recorded by the 
Inspector vision sensor. This means that 
the defective parts can be separated and 
removed from the process reliably.`
      },
      {
        number: "2",
        title: "Gripper function monitoring",
        text: ` The magnetic cylinder sensor 
monitors the pneumatic cylinder in the 
gripper. The sensor has two switching 
points. This means that both end posi
tions of the short stroke cylinder can be 
monitored with just one sensor and one 
connecting cable. The IME08 inductive 
proximity sensor detects the end posi
tion of the flap axis integrated into the 
gripper.`
      },
      {
        number: "3",
        title: "Checking the presence and position of trays",
        text: ` To control the conveying line, it is nec
essary to check whether the trays to be 
transported are present and whether 
they are in the correct position. The 
WTB12-3 small photoelectric sensor 
is used for this purpose. In addition to 
detecting the trays, this photoelectric 
sensor can also detect the position of 
the trays using the background suppres
sion function.`
      },
      {
        number: "4",
        title: "Checking presence and fill level in the singulation system",
        text: ` To ensure that the vibration drives of a 
bowl feeder and the linear conveyors 
connected to it are not continually in 
operation, the presence of the material 
to be conveyed must be checked at 
various points in the singulation system. 
To ensure this occurs, all the material 
placed on the linear conveyor is detected 
using the rugged and easily adjustable 
WFL fork sensor. The WLL180 fiber-optic 
sensor is even able to monitor the pres
ence of parts on the loading pallet when 
the space available is severely limited. 
The UP56 ultrasonic level sensor is used 
to check how full the bowl feeder is.`
      },
      {
        number: "5",
        title: "Collision protection between the robot and the injection molding tool",
        text: ` Closing the injection molding tool while 
a robot is accessing it damages both the 
tool and the robot. The access opening 
to the tool area can be monitored reliably 
with the SGS smart light grid or, alterna
tively, with the 2D laser scanner.`
      },
      {
        number: "6",
        title: " Detecting parts in the gripper and the injection molding tool",
        text: ` There is very limited room available for 
sensors in the robot gripper and the 
injection molding tool. For this reason, 
the W2 Flat miniature photoelectric 
sensor is the ideal choice for detecting 
inserts and finished parts so that they 
can then be placed in the gripper. The 
WLL180T fiber-optic sensor, featuring 
high temperature-resistant LL3 fibers, is 
perfect for use in injection molding tools.`
      },
      {
        number: "7",
        title: "  Access protection for a robot cell",
        text: `  The rugged Lock safety locking 
device locks the door to the work cell 
and ensures that all process steps 
are completed before the door can be 
opened. When the door is open, the  
Lock prevents start-up of the system. 
The door must be closed for the system 
to restart.`
      }
    ].map((item, idx) => (
      <div className="info-card small" key={idx}>
        <div className="card-title">
          <span className="card-number">{item.number}</span>
          <span className="card-heading">{item.title}</span>
        </div>
        <p>{item.text}</p>
      </div>
    ))}
  </div>
</section>



<section className="rubber-injection-machine">
  <div className="machine-image">
    <img src={rubber4} alt=" Blown film extrusion line" />
  </div>

  <div className="horizontal-card-wrapper">
    {[
      {
        number: "1",
        title: " Safe control solution",
        text: ` The modular Flexi Soft safety controller is 
responsible for complete monitoring of 
allsafety functions of the extrusion line. 
All safety functions, such as the safety 
switch, emergency stop pushbutton,
and opto-electronic protective devices, 
are easy to connect and interconnect. 
Gateways for all conventional fieldbus 
systems are also available.`
      },
      {
        number: "2",
        title: "Access protection at the winding unit",
        text: ` The continuous action of winding up 
a film sheet represents a dangerous 
movement. The deTec4 Core safety light 
curtain reliably monitors access to the 
winding unit.`
      },
      {
        number: "3",
        title: "Measurement of the roller diameter",
        text: `The distance sensor measures 
the height of the material on the bobbin 
as the film sheet is wound onto the coil. 
This detects when a bobbin is full and 
must be replaced with an empty one.`
      },
      {
        number: "4",
        title: "Speed measuring",
        text: ` The incremental encoder mon
itors the speed of the film sheet on a 
roller. This enables the film sheet to be 
wound up onto the coil at a constant 
rate. It is highly rugged and can 
be individually configured.`
      },
      {
        number: "5",
        title: "Edge guiding",
        text: ` Array sensors enable precise lead
ing edge detection of extruded profiles. 
They offer a high repeatability of 0.03 
mm and can detect even the smallest 
grayscale variations in the visible area.`
      },
      {
        number: "6",
        title: " Determining the film tubing diameter",
        text: `The diameter of the film tubing is deter
mined by the signal evaluation function 
of three UM30 ultrasonic sensors. The 
air feed is controlled based on this 
diameter, which ensures a consistent, 
high-quality production result.`
      },
      {
        number: "7",
        title: "Mobile hazardous area protection",
        text: ` The safety laser scanners protect automated guided 
vehicles against collisions with people, 
other vehicles, and materials on the 
floor. Safety laser scanners can receive 
speed information via dynamic inputs. 
The appropriate protective field is acti
vated based on this information.`
      }
    ].map((item, idx) => (
      <div className="info-card small" key={idx}>
        <div className="card-title">
          <span className="card-number">{item.number}</span>
          <span className="card-heading">{item.title}</span>
        </div>
        <p>{item.text}</p>
      </div>
    ))}
  </div>
</section>










<section className="rubber-injection-machine">
  <div className="machine-image">
    <img src={rubber5} alt=" Thermoforming, bag and sack production and weaving machine" />
  </div>

  <div className="horizontal-card-wrapper">
    {[
      {
        number: "1",
        title: "Loop control",
        text: ` The distance sensor controls the 
feed of plastic film into the thermoform
ing machine. It is positioned via the loop 
and either measures the slack of the film 
continually or signals two distance points 
previously taught in.`
      },
      {
        number: "2",
        title: "Hazardous point protection on a thermoforming machine",
        text: `The safety light curtain 
provides a straightforward protection 
method against reaching under and 
into a dangerous area. Two  
safety light curtains form a cascade. This 
secures the access area to the thermo
forming machine.`
      },
      {
        number: "3",
        title: "Identifying film and fabric rollers",
        text: ` Over the entire manufacturing process, it 
must be possible to trace the production 
material. Important information such as 
the type of material, film thickness, sheet 
width, and additional parameters is con
tained in the bar codes. The CLV650 bar 
code scanner reads these codes.`
      },
      {
        number: "4",
        title: "Edge guiding",
        text: ` The Inspector vision sensor pre
cisely determines the leading edge of 
the film web and passing on the position 
information. For two-point leading edge 
control a system of cylindrical 
photoelectric sensors could be an alter
native solution.`
      },
      {
        number: "5",
        title: "Detecting print marks",
        text: `The KT5 contrast sensor precisely and 
quickly detects printing marks in a 
wide range of different colors. Machine 
functions such as foil cutting can be 
controlled reliably using these printing 
marks.`
      },
      {
        number: "6",
        title: "Measuring the film tension",
        text: `When a continuous tubular film is being 
processed into a finished plastic bag, the 
f
 ilm sheet must be kept under tension in 
the bag fabrication machine. The MPS 
analog positioning sensor detects the 
film tension using the position of the 
deflection roller.`
      },
      {
        number: "7",
        title: " Measuring the sheet width on the weaving machine",
        text: `Two array sensors measure the 
width of the sheet of fabric. This ensures 
that a fabric tube with a uniform diame
ter is produced.`
      },
    ].map((item, idx) => (
      <div className="info-card small" key={idx}>
        <div className="card-title">
          <span className="card-number">{item.number}</span>
          <span className="card-heading">{item.title}</span>
        </div>
        <p>{item.text}</p>
      </div>
    ))}
  </div>
</section>

<OurProductsSection />
      {/* <section className="action-buttons-section">
        <a href={RubberAndPlasticPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-btn">📄 Download</button>
        </a>
          <button className="quote-btn" onClick={() => setShowModal(true)}>📩 Request a Quote</button>
          <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} />
      </section> */}

      <Footer />
    </div>
  );
};
export default RubberAndPlastic;